export function normalizeLoomLink(maybeLoomLink: string): string | null {
  if (!maybeLoomLink.includes('loom.com/share/')) {
    return null;
  }
  return maybeLoomLink.startsWith('https://') ? maybeLoomLink : `https://${maybeLoomLink}`;
}
